// extracted by mini-css-extract-plugin
export default {"wrapper":"navigation_wrapper__BceLf","default":"navigation_default__NKUgE","active":"navigation_active__gWl-4"};